<div class="feedback-dialog">
  <nb-card>
    <nb-card-header>
      <div class="header-text">{{ 'FEEDBACK.DIALOG.FEEDBACK_1' | translate }}</div>
      <div class="header-icon">
        <nb-icon icon="close-outline" pack="eva" class="close-dialog" (click)="closeDialog()">
        </nb-icon>
      </div>
    </nb-card-header>
    <nb-card-body>
      <div class="feedback-card">
        <div *ngIf="!feedbackSent">
          <h4>{{ 'FEEDBACK.DIALOG.FEEDBACK_2' | translate }}</h4>
          <p>
            {{ 'FEEDBACK.DIALOG.FEEDBACK_3' | translate }}
          </p>
          <form [formGroup]="feedbackForm" (ngSubmit)="onSubmit()">
            <div class="star-rating">
              <h6>{{ 'FEEDBACK.DIALOG.FEEDBACK_4' | translate }}</h6>
              <ng-template #t let-fill="fill">
                <span class="star" [class.full]="fill === 100">
                  <span class="half" [style.width.%]="fill">&#9733;</span>&#9733;
                </span>
              </ng-template>
              <ngb-rating
                [starTemplate]="t"
                [readonly]="false"
                [max]="5"
                formControlName="ratingCtrl"
                class="rating"
              ></ngb-rating>
              <div class="form-text small">
                <div
                  *ngIf="
                    feedbackForm.controls.ratingCtrl.dirty && feedbackForm.controls.ratingCtrl.valid
                  "
                  class="text-success"
                >
                  {{ 'FEEDBACK.DIALOG.FEEDBACK_5' | translate }}
                </div>
                <div *ngIf="feedbackForm.controls.ratingCtrl.pristine" class="text-primary">
                  {{ 'FEEDBACK.DIALOG.FEEDBACK_6' | translate }}
                </div>
              </div>
            </div>
            <div class="textual-feedback" formGroupName="feedback">
              <h6>{{ 'FEEDBACK.DIALOG.FEEDBACK_7' | translate }}</h6>
              <p>{{ 'FEEDBACK.DIALOG.VALIDATION_MSG' | translate }}</p>
              <div>
                <nb-tabset>
                  <nb-tab tabTitle="{{ 'FEEDBACK.DIALOG.FEEDBACK_8' | translate }}">
                    <textarea
                      nbInput
                      fullWidth
                      formControlName="suggestionsCtrl"
                      placeholder="{{ 'FEEDBACK.DIALOG.FEEDBACK_8a' | translate }}"
                      class="textarea-feedback"
                    ></textarea>
                  </nb-tab>
                  <nb-tab tabTitle="{{ 'FEEDBACK.DIALOG.FEEDBACK_9' | translate }}">
                    <textarea
                      nbInput
                      fullWidth
                      formControlName="errorsCtrl"
                      placeholder="{{ 'FEEDBACK.DIALOG.FEEDBACK_9a' | translate }}"
                      class="textarea-feedback"
                    ></textarea>
                  </nb-tab>
                  <nb-tab tabTitle="{{ 'FEEDBACK.DIALOG.FEEDBACK_10' | translate }}">
                    <textarea
                      nbInput
                      fullWidth
                      formControlName="complimentsCtrl"
                      placeholder="{{ 'FEEDBACK.DIALOG.FEEDBACK_10a' | translate }}"
                      class="textarea-feedback"
                    ></textarea>
                  </nb-tab>
                </nb-tabset>
                <div class="feedback-actions">
                  <button nbButton status="success" [disabled]="!feedbackForm.valid">
                    {{ 'FEEDBACK.DIALOG.FEEDBACK_11' | translate }}
                  </button>
                </div>
              </div>
            </div>
          </form>
        </div>
        <div *ngIf="feedbackSent">
          <h4>{{ 'FEEDBACK.DIALOG.FEEDBACK_12' | translate }}</h4>
          <p>{{ 'FEEDBACK.DIALOG.FEEDBACK_13' | translate }}</p>
        </div>
      </div>
    </nb-card-body>
    <nb-card-footer>{{ title }}</nb-card-footer>
  </nb-card>
</div>
